<template>
	<div>
		<table>
			<thead>
				<tr class="body-text-1">
					<th class="th-question__type " @click="sortColumn('name')">
						<div class="th-sort">
							<span>{{ $t('name') }}</span>

							<span v-if="sortedColumn === 'name'">
								<svgicon :name="isSorted ? 'arrowUp' : 'arrowDown'"> </svgicon>
							</span>
						</div>
					</th>
					<th class="th-question__actions">{{ $t('actions') }}</th>
				</tr>
			</thead>
			<tbody class="body-text-2">
				<tr class="search-row">
					<td class="td-input">
						<label class="custom-input">
							<svgicon name="search"> </svgicon>
							<input v-model="searchInterestName" />
						</label>
					</td>
					<td></td>
				</tr>
				<tr
					v-for="(row, index) in displayedData"
					:key="index"
					class="table-row"
				>
					<td>{{ row.name }}</td>
					<td class="td-center">
						<button class="action-button" @click="editRow(row)">
							<svgicon
								v-if="(isSuperAdmin || isUSAAdmin) && selectedFacilityId == 0"
								name="pencil"
							></svgicon>
							<svgicon
								v-if="!(isSuperAdmin || isUSAAdmin) || selectedFacilityId > 0"
								name="search"
							></svgicon>
						</button>
						<button
							v-if="(isSuperAdmin || isUSAAdmin) && selectedFacilityId == 0"
							class="action-button"
							@click="openDeleteModal(row)"
						>
							<svgicon name="trash"></svgicon>
						</button>
					</td>
				</tr>
			</tbody>
		</table>
		<ja-pagination
			:current="currentPage"
			:data-per-page="itemsPerPage"
			:data-count="filteredData.length"
			@changePage="setAllPage"
		></ja-pagination>
		<ja-confirm-modal
			:show="showMessageDeletionModal"
			:title="$t('confirmation')"
			:confirm-text="$t('yes')"
			:cancel-text="$t('no')"
			class="confirm-modal--medium"
			@confirm="deleteInterest()"
			@closeModal="closeMessageDeletionModal()"
			@cancel="closeMessageDeletionModal()"
		>
			<h3 class="body-text-2">
				{{
					$t('deleteMessageCms', {
						title: $t('interest')
					})
				}}
			</h3>
		</ja-confirm-modal>
	</div>
</template>
<script>
import Pagination from '@/components/AdminSection/elements/Pagination';
import ConfirmModal from '@/components/Modal/ConfirmModal.vue';
import AdminFacility from '@/mixins/AdminFacility';
import '@/components/icons/cms/search';
import '@/components/icons/cms/pencil';
import '@/components/icons/cms/trash';
import '@/components/icons/cms/arrowDown';
import '@/components/icons/cms/arrowUp';

export default {
	components: {
		jaConfirmModal: ConfirmModal,
		jaPagination: Pagination
	},
	mixins: [AdminFacility],
	props: {
		data: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			showMessageDeletionModal: false,
			sortedColumn: null,
			sortOrder: 1,
			isSorted: false,
			searchInterestName: '',
			currentPage: 1,
			itemsPerPage: 150,
			interestNameIndex: 0,
			deleteRow: null
		};
	},
	computed: {
		filteredData() {
			let filteredData = this.data.filter(row =>
				row.name.toLowerCase().includes(this.searchInterestName.toLowerCase())
			);

			if (this.sortedColumn) {
				filteredData = filteredData.sort((a, b) => {
					const fieldA = a[this.sortedColumn].toLowerCase();
					const fieldB = b[this.sortedColumn].toLowerCase();
					return (fieldA > fieldB ? -1 : 1) * this.sortOrder;
				});
			}
			return filteredData;
		},
		displayedData() {
			const start = (this.currentPage - 1) * this.itemsPerPage;
			const filteredData = this.filteredData.slice(
				start,
				start + this.itemsPerPage
			);
			return filteredData;
		},
		totalPages() {
			return Math.ceil(this.data.length / this.itemsPerPage);
		},
		showPagination() {
			return this.totalPages > 1;
		}
	},
	watch: {
		displayedData() {
			this.currentPage = this.currentPage <= 0 ? 1 : this.currentPage;
		}
	},
	methods: {
		sortTable() {
			this.sortOrder = this.sortOrder * -1;
			this.sortedColumn = null;
		},
		sortColumn(column) {
			this.sortedColumn = column;
			this.sortOrder = this.sortOrder * -1;
			this.isSorted = !this.isSorted;
		},
		changePage(pageNumber) {
			this.currentPage = pageNumber;
		},
		editRow(row) {
			this.$emit('editRow', row);
		},
		openDeleteModal(row) {
			this.deleteRow = row;
			this.showMessageDeletionModal = true;
		},
		setAllPage(page) {
			this.currentPage = page;
		},
		deleteInterest() {
			this.showMessageDeletionModal = false;
			this.$emit('deleteRow', this.deleteRow);
		},
		closeMessageDeletionModal() {
			this.showMessageDeletionModal = false;
		}
	}
};
</script>
<style lang="scss" scoped>
table {
	width: 100%;
	border-collapse: collapse;
	margin-top: 10px;
}
.td-input {
	padding: 0;
}
.th-question {
	&__type {
		width: 90%;
	}
	&__actions {
		width: 10%;
	}
}
.td-center {
	text-align: center;
	text-align: -webkit-center;
}
.th-sort {
	cursor: pointer;
	display: flex;
	justify-content: space-between;
}

.custom-input {
	display: flex;
	border-radius: 4px;
	border: 1px solid #ddd;
	box-shadow: inset 0 0 5px 0px rgba(0, 0, 0, 0.15);
	padding: 7px 5px;
	margin: 1px;
	gap: 5px;
}

.custom-input input {
	border: none;
	outline: none;
	width: 100%;
}
.custom-input:focus-within {
	outline: 2px solid $hover-state;
	box-shadow: inset 0 0 5px 0px rgba(0, 0, 0, 0.15);
}
.action-button {
	background-color: transparent;
	border: none;
	cursor: pointer;
	padding: 0 10px;
}

th,
td {
	border: 1px solid #ddd;
	padding: 8px;
	text-align: left;
}

th {
	background-color: #ffff;
}
</style>
